import { Link } from 'react-router-dom';
import { openCookiePreferences } from '@/lib/consent';

const Privacy = () => {
  const updated = 'February 2026';
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800" data-testid="privacy-policy-page">
      <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-3">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-10">Last updated: {updated}</p>

      <div className="space-y-8 leading-relaxed">
        <section>
          <p>
            GN Management Inc. (&quot;GN Management,&quot; &quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) respects your privacy. This Privacy Policy explains what
            information we collect when you use gnmgt.com (the &quot;Site&quot;), how we use it, and the choices you have.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Information We Collect</h2>
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li><strong>Contact information</strong> you submit through inquiry, contact, or interest forms (name, email, phone, message).</li>
            <li><strong>Usage information</strong> collected only with your consent through analytics tools — pages visited, referring URL, device type, approximate location.</li>
            <li><strong>Technical information</strong> such as IP address and browser type, used solely for security and to keep the Site running.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>To respond to your inquiries and provide the services you request.</li>
            <li>To improve the Site&apos;s content, layout, and performance.</li>
            <li>To comply with applicable law and protect our legal rights.</li>
          </ul>
          <p className="text-sm mt-2">We do not sell your personal information.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Cookies & Tracking</h2>
          <p className="text-sm">
            We use cookies and similar technologies as described in our{' '}
            <Link to="/cookies" className="text-[#20B2AA] hover:underline">Cookie Policy</Link>.
            No analytics or tracking cookies are set unless you explicitly consent.
          </p>
          <button
            onClick={openCookiePreferences}
            className="mt-3 text-sm text-[#20B2AA] hover:underline"
            data-testid="privacy-open-cookie-prefs"
          >
            Manage Cookie Preferences
          </button>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Your Rights</h2>
          <p className="text-sm">
            Depending on where you live, you may have the right to access, correct, delete, or port your personal information, or to withdraw
            consent at any time. To exercise these rights, contact us at{' '}
            <a href="mailto:inquiry@gnmgt.com" className="text-[#20B2AA] hover:underline">inquiry@gnmgt.com</a>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Data Retention & Security</h2>
          <p className="text-sm">
            We retain personal information only for as long as needed to fulfill the purpose it was collected for and use reasonable technical and
            organizational safeguards to protect it. No system is 100% secure.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Third-Party Services</h2>
          <p className="text-sm">
            We use Google Analytics 4 and PostHog for anonymized usage analytics, Cloudinary for image delivery, and Resend for transactional
            email. These providers process data on our behalf under their own privacy terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Contact</h2>
          <p className="text-sm">
            GN Management Inc., 30 Hudson St, Jersey City, NJ 07302 —{' '}
            <a href="mailto:inquiry@gnmgt.com" className="text-[#20B2AA] hover:underline">inquiry@gnmgt.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
